module.exports = __webpack_public_path__ + "img/27682cd18298597cb88eda1a49b3cb04.9c191734.jpg";